import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { createSelector } from "reselect";
import { logoutUser } from "../../pages/Authentication/service/loginService";
import { useNavigate } from "react-router-dom";
import { logoutModal, verifyModal } from "../../slices/common/reducer";
import { useDispatch } from "react-redux";
import LogoutModal from "../../pages/Authentication/Modal/LogoutModal";

const ProfileDropdown = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profiledropdownData = createSelector(
    (state) => state.Profile,
    (user) => user.user
  );
  const verifyShow = useSelector((state) => state.common.verifyShow);
  const userInfo = useSelector((state) => state.common.userInfo);

  // Inside your component
  const user = useSelector(profiledropdownData);

  // const [userName, setUserName] = useState("Admin");

  // useEffect(() => {
  //   if (localStorage.getItem("name")) {
  //     const obj = localStorage.getItem("name");
  //     setUserName(obj);
  //   }
  // }, [userName, user]);
  //   useEffect(() => {
  //     const usernameFromLocalStorage = localStorage.getItem("firstName");
  //     if (user && user.username) {
  //       setUserName(user.username);
  //       localStorage.setItem("username", user.username); // Update local storage
  //     } else if (usernameFromLocalStorage) {
  //       setUserName(usernameFromLocalStorage);
  //     }
  //   }, [user]);

  //Dropdown Toggle
  const userName = userInfo?.name;

  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  const handleLogoutClick = () => {
    dispatch(logoutModal(true));
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
        style={{ width: "auto" }}
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            <div
              className="rounded-circle header-profile-user d-flex align-items-center justify-content-center"
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "#6c757d",
                color: "#fff",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              {userName ? userName.charAt(0).toUpperCase() : ""}
            </div>
            <span className="text-start ms-xl-2">
              <span
                className="d-none d-xl-inline-block ms-1 fw-medium user-name-text"
                style={{ wordBreak: "break-all" }}
              >
                {userName}
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <h6 className="dropdown-header">Welcome {userName}!</h6>
          {/* <DropdownItem href="/profile">
            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Profile</span>
          </DropdownItem>
          <DropdownItem href="/apps-chat">
            <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Messages</span>
          </DropdownItem>
          <DropdownItem href="#">
            <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Taskboard</span>
          </DropdownItem>
          <DropdownItem href="/pages-faqs">
            <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Help</span>
          </DropdownItem>
          <div className="dropdown-divider"></div>
          <DropdownItem href="/pages-profile">
            <i className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">
              Balance : <b>$5971.67</b>
            </span>
          </DropdownItem>
          <DropdownItem href="/pages-profile-settings">
            <span className="badge bg-success-subtle text-success mt-1 float-end">
              New
            </span>
            <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Settings</span>
          </DropdownItem>
          <DropdownItem href="/auth-lockscreen-basic">
            <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Lock screen</span>
          </DropdownItem> */}
          <DropdownItem onClick={handleLogoutClick}>
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle" data-key="t-logout">
              Logout
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <LogoutModal />
    </React.Fragment>
  );
};

export default ProfileDropdown;
